import { render, staticRenderFns } from "./form-bulk-edit.vue?vue&type=template&id=56c19e8a&"
import script from "./form-bulk-edit.vue?vue&type=script&lang=js&"
export * from "./form-bulk-edit.vue?vue&type=script&lang=js&"
import style0 from "./form-bulk-edit.vue?vue&type=style&index=0&id=56c19e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports